import { RootState } from 'duck/store'
import { identity, map } from 'lodash'
import { createSelector } from 'reselect'

import { getDataState } from '../selectors'
import { Organization, ORGANIZATIONS_STORE_ID } from './types'

const getOrganizationsState = createSelector(getDataState, (dataState) => dataState[ORGANIZATIONS_STORE_ID])

export const getAllOrganizations = createSelector(
  getOrganizationsState,
  (organizationsState) => organizationsState.items
)

export const getOrganization = (state: RootState, organizationId: Organization['id'] | undefined) => {
  if (!organizationId) {
    return undefined
  }
  return createSelector(getAllOrganizations, (allOrganizations) => allOrganizations[organizationId])(state)
}

export const getOrganizationName = createSelector(getOrganization, (organization) => {
  if (!organization) {
    return undefined
  }
  return organization.name
})

export const getOrganizationFundingRounds = createSelector(
  getOrganization,
  (organization: Organization | undefined) => {
    if (!organization) {
      return undefined
    }
    return organization.fundingRounds
  }
)

export const getIsFetchingOrganizations = createSelector(
  getOrganizationsState,
  (organizationsState) => organizationsState.isFetching || organizationsState.items === {}
)

export const getAllOrganizationsIds = createSelector(getAllOrganizations, (allOrganizations) =>
  Object.keys(allOrganizations).map(Number)
)

export const getAllOrganizationsNames = createSelector(
  getAllOrganizations,
  (allOrganizations) => map(allOrganizations, (organization) => organization.name).filter(identity) as string[]
)

export function getOrganizationPositions({ positions }: Pick<Organization, 'positions'>) {
  if (!positions) {
    return []
  }

  return positions
}
